import { render, staticRenderFns } from "./page-settings.vue?vue&type=template&id=693bff63&scoped=true&"
import script from "./page-settings.vue?vue&type=script&lang=js&"
export * from "./page-settings.vue?vue&type=script&lang=js&"
import style0 from "./page-settings.vue?vue&type=style&index=0&id=693bff63&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693bff63",
  null
  
)

export default component.exports